import { Component } from '@angular/core';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';
import { BaseAction } from '../base-action';
import { BaseRuleAction } from '../base-rule-action';
import { CreateAlarmRuleAction } from './create-alarm.rule-action';

@Component({
  selector: 'app-create-alarm-action',
  imports: [
    TranslateSafePipe,
  ],
  templateUrl: './create-alarm-action.html',
  styleUrls: [
    './create-alarm-action.css',
    '../base-rule-action.css',
  ],
})
export class CreateAlarmAction extends BaseAction {
  override ruleAction: BaseRuleAction = new CreateAlarmRuleAction();

}
